export default __webpack_public_path__ + "cf87bf69594754d5abaa89bc5a2b849b.svg";